import VI_Lang from "@assets/images/Languages/vietnam.png";
import EN_Lang from "@assets/images/Languages/english.png";
import KO_Lang from "@assets/images/Languages/korea.png";
import JA_Lang from "@assets/images/Languages/japan.png";
import ZH_Lang from "@assets/images/Languages/china.png";
import KM_Lang from "@assets/images/Languages/campuchia.png";
import HI_Lang from "@assets/images/Languages/india.png";
import DE_Lang from "@assets/images/Languages/germany.png";
import FR_Lang from "@assets/images/Languages/france.png";
import PT_Lang from "@assets/images/Languages/portuga.png";
import ES_Lang from "@assets/images/Languages/spain.png";
import IT_Lang from "@assets/images/Languages/italy.png";
import AR_Lang from "@assets/images/Languages/arab.png";
import RU_Lang from "@assets/images/Languages/russia.png";
import ID_Lang from "@assets/images/Languages/vietnam.png";
import MS_Lang from "@assets/images/Languages/vietnam.png";
import TH_Lang from "@assets/images/Languages/vietnam.png";
import LO_Lang from "@assets/images/Languages/vietnam.png";
import MY_Lang from "@assets/images/Languages/vietnam.png";
import AF_Lang from "@assets/images/Languages/english.png";
import BN_Lang from "@assets/images/Languages/india.png";
import ZH_TW_Lang from "@assets/images/Languages/china.png";
import TL_Lang from "@assets/images/Languages/english.png";
import HA_Lang from "@assets/images/Languages/english.png";
import MM_Lang from "@assets/images/Languages/vietnam.png";
import SW_Lang from "@assets/images/Languages/english.png";
import TR_Lang from "@assets/images/Languages/germany.png";
import UR_Lang from "@assets/images/Languages/india.png";
import { PERMISSION } from "@constants/common";
import _ from "lodash";
// import { ADMIN, AUTHOR, EDITOR, PERMISSION, SYSADMIN } from "../constants/common";
// import _ from "lodash";

export const mapKeyToLanguage = (key: string) => {
  switch (key) {
    case "vi": {
      return VI_Lang;
    }
    case "en": {
      return EN_Lang;
    }
    case "ko": {
      return KO_Lang;
    }
    case "ja": {
      return JA_Lang;
    }
    case "zh": {
      return ZH_Lang;
    }
    case "km": {
      return KM_Lang;
    }
    case "hi": {
      return HI_Lang;
    }
    case "de": {
      return DE_Lang;
    }
    case "fr": {
      return FR_Lang;
    }
    case "pt": {
      return PT_Lang;
    }
    case "es": {
      return ES_Lang;
    }
    case "it": {
      return IT_Lang;
    }
    case "ar": {
      return AR_Lang;
    }
    case "ru": {
      return RU_Lang;
    }
    case "id": {
      return ID_Lang;
    }
    case "ms": {
      return MS_Lang;
    }
    case "th": {
      return TH_Lang;
    }
    case "lo": {
      return LO_Lang;
    }
    case "my": {
      return MY_Lang;
    }
    case "af": {
      return AF_Lang;
    }
    case "bn": {
      return BN_Lang;
    }
    case "zh-TW": {
      return ZH_TW_Lang;
    }
    case "tl": {
      return TL_Lang;
    }
    case "ha": {
      return HA_Lang;
    }
    case "mm": {
      return MM_Lang;
    }
    case "sw": {
      return SW_Lang;
    }
    case "tr": {
      return TR_Lang;
    }
    case "ur": {
      return UR_Lang;
    }
    default: {
      return VI_Lang;
    }
  }
};


export const media9codeOrCms = (id: string) => {
  // const mediaAPi = `${window.origin}/media/api/files/view?id=:id`;
  const mediaApi = `${process.env.REACT_APP_API_IMG}/api/files/view?id=:id`
  if (!id) return;
  if (id.length === 8) {
    return mediaApi.replace(":id", id)
  } else if (id.length === 24) {
    return `${process.env.REACT_APP_API}/api/media/view/${id}`
  } else {
    return id;
  }
}


export const permission = (key: string) => {
  const role : any = localStorage.getItem('role');
  return _.get(PERMISSION, key).includes(role);
}


const DEFAULT_SLUG_PART_LENGTH = 70;
const MAX_FULL_SLUG_LENGTH = 120;

const truncateSlug = (slug: string, maxLength: number): string => {
  if (!slug || slug.length <= maxLength) return slug;

  const sliced = slug.slice(0, maxLength);
  const lastDash = sliced.lastIndexOf("-");

  if (lastDash > 0) {
    return sliced.slice(0, lastDash);
  }

  return sliced;
};

const sanitizeIdForSlug = (id: string): string => {
  return (id || "")
    .replace("ninetick-", "")
    .replace(/[^a-zA-Z0-9-]/g, "")
    .toLowerCase();
};

const buildSlugWithId = (baseSlug: string, id: string): string => {
  const safeId = sanitizeIdForSlug(id);
  const safeBase = baseSlug || "article";

  if (!safeId) {
    return truncateSlug(safeBase, MAX_FULL_SLUG_LENGTH);
  }

  const maxBaseLength = Math.max(10, MAX_FULL_SLUG_LENGTH - safeId.length - 1);
  const truncatedBase = truncateSlug(safeBase, maxBaseLength) || "article";
  return `${truncatedBase}-${safeId}`;
};

/**
 * Bỏ dấu / chuyển ký tự Latin mở rộng về ASCII cho slug (Thổ, Đức, Pháp, Bắc Âu…).
 * Chạy sau bước map tiếng Việt.
 */
const stripExtendedLatinForSlug = (input: string): string => {
  let s = input
    .replace(/ß/g, "ss")
    .replace(/ẞ/g, "SS")
    .normalize("NFKD")
    .replace(/\p{M}/gu, "");

  s = s
    .replace(/\u0131/g, "i")
    .replace(/\u0130/g, "I")
    .replace(/æ/gi, "ae")
    .replace(/œ/gi, "oe")
    .replace(/ø/g, "o")
    .replace(/Ø/g, "O")
    .replace(/ð/g, "d")
    .replace(/Ð/g, "D")
    .replace(/þ/g, "th")
    .replace(/Þ/g, "TH")
    .replace(/ł/g, "l")
    .replace(/Ł/g, "L")
    .replace(/ſ/g, "s");

  return s;
};

export function stringToSlug(str: string, maxLength: number = DEFAULT_SLUG_PART_LENGTH) {
  if (!str) return "";

  // Tiếng Việt: map trực tiếp (đ/ă/ơ/ư…)
  const from = "àáãảạăằắẳẵặâầấẩẫậèéẻẽẹêềếểễệđùúủũụưừứửữựòóỏõọôồốổỗộơờớởỡợìíỉĩịäëïîöüûñçýỳỹỵỷ",
    to = "aaaaaaaaaaaaaaaaaeeeeeeeeeeeduuuuuuuuuuuoooooooooooooooooiiiiiaeiiouuncyyyyy";
  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(RegExp(from[i], "gi"), to[i]);
  }

  str = stripExtendedLatinForSlug(str);

  str = str
    .replace(/['"`’]/g, "")
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .toLowerCase()
    .trim();

  return truncateSlug(str, maxLength);
}

export function stringToLocalizedSlug(str: string, maxLength: number = DEFAULT_SLUG_PART_LENGTH) {
  if (!str) return "";

  str = str
    .replace(/[\u0000-\u001F\u007F]/g, " ")
    .replace(/[!-/:-@[-`{-~]/g, " ")
    .replace(/[“”‘’‚„…–—―·•。、「」『』【】（）《》〈〉！？：；，、]/g, " ")
    .replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/gu, " ")
    .replace(/[_\s]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .toLowerCase()
    .trim();

  return truncateSlug(str, maxLength);
}

/**
 * Ngôn ngữ dùng slug Unicode (stringToLocalizedSlug) + ghép id.
 * Khớp với các mã trong LANGUAGE dùng chữ không Latin:
 * ar, bn, zh, zh-TW, hi, ja, km, ko, lo, mm, ru, th, ur
 * (my: alias Myanmar nếu API cũ gửi 'my' thay vì 'mm')
 */
export const NON_LATIN_SLUG_LANGUAGES: string[] = [
  "ko",
  "ja",
  "zh",
  "zh-TW",
  "ru",
  "ar",
  "th",
  "lo",
  "my",
  "mm",
  "bn",
  "hi",
  "ur",
  "km"
];

/**
 * Tiêu đề hỗn hợp Latin + CJK/Khmer/Arabic…: stringToSlug chỉ còn vài ký tự (vd. "qr") → trùng slug.
 * Dùng cùng luận với createMultilingualSlug Unicode dù ngôn ngữ giao diện là en/fr/...
 */
export function shouldPreferUnicodeSlug(title: string): boolean {
  if (!title || !title.trim()) return false;
  const latinSlug = stringToSlug(title);
  if (latinSlug.length >= 3) return false;
  const compact = title.replace(/\s/g, "");
  return compact.length > Math.max(latinSlug.length, 1) + 2;
}

/**
 * Tạo slug đa ngôn ngữ, hỗ trợ các ngôn ngữ không phải Latin như tiếng Hàn, Nhật, Trung
 * @param title Tiêu đề bài viết
 * @param id ID của bài viết (để đảm bảo tính duy nhất)
 * @param language Mã ngôn ngữ (ja, ko, zh, v.v.)
 * @returns Promise<string> Trả về slug được tạo
 */
export async function createMultilingualSlug(title: string, id: string, language: string): Promise<string> {
  const fallbackSlug = buildSlugWithId("article", id);

  // Nếu tiêu đề trống hoặc không xác định, trả về slug với chỉ id
  if (!title || title.trim() === '') {
    return fallbackSlug;
  }

  // Unicode slug: ngôn ngữ script không Latin, hoặc tiêu đề hỗn hợp chữ
  if (NON_LATIN_SLUG_LANGUAGES.includes(language) || shouldPreferUnicodeSlug(title)) {
    // Ưu tiên slug theo đúng ngôn ngữ đích để tối ưu SEO bản địa
    const localizedSlug = stringToLocalizedSlug(title, DEFAULT_SLUG_PART_LENGTH);
    if (localizedSlug.length >= 3) {
      return buildSlugWithId(localizedSlug, id);
    }

    // Fallback thuần local, không gọi dịch AI từ admin-webapp.
    const slugFromOriginal = stringToSlug(title, DEFAULT_SLUG_PART_LENGTH);
    if (slugFromOriginal.length >= 3) {
      return buildSlugWithId(slugFromOriginal, id);
    }

    return fallbackSlug;
  } else {
    // Với các ngôn ngữ Latin, sử dụng hàm stringToSlug hiện có
    const slugFromTitle = stringToSlug(title, DEFAULT_SLUG_PART_LENGTH);
    return buildSlugWithId(slugFromTitle, id);
  }
}
